import type { CommonOptions } from "bm-ui-kit";

export const LOAN_GOALS: CommonOptions = [
	{
		value: "EPITES",
		label: "Építés",
	},
	{
		value: "BOVITES",
		label: "Bővítés",
	},
	{
		value: "UJ_LAKAS",
		label: "Új lakás vásárlás",
	},
	{
		value: "FELUJITAS",
		label: "Felújítás",
	},
	{
		value: "KORSZERUSITES",
		label: "Korszerűsítés",
	},
	{
		value: "HASZNALT_LAKAS",
		label: "Használt lakás vásárlás",
	},
];

export const NUMBER_OF_CHILDREN: CommonOptions<number> = [
	{ label: "Nincs gyerekem", value: 0 },
	{ label: "Egy", value: 1 },
	{ label: "Kettő", value: 2 },
	{ label: "Három", value: 3 },
	{ label: "Négy vagy több", value: 4 },
];

export const NUMBER_OF_CHILDREN_COMMITMENT: CommonOptions<number> = [
	{ label: "Nem tervezünk többet", value: 0 },
	{ label: "Egy", value: 1 },
	{ label: "Kettő", value: 2 },
	{ label: "Három vagy több", value: 3 },
];

export const SOCIAL_INSURANCE_SINCE: CommonOptions<number> = [
	{
		value: 1,
		label: "Kevesebb, mint fél éve",
	},
	{
		value: 2,
		label: "Fél év és 2 év között",
	},
	{
		value: 3,
		label: "Legalább 2 éve",
	},
];
